import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { FilterConfig } from "../../schemas";
import { MobileFilterCategorySheet } from "../MobileFilterCategorySheet/MobileFilterCategorySheet";
import { useModal, ModalTypeEnum } from "@/components/providers/modal-provider/ModalProvider";
import { useTranslations } from "next-intl";
import { useMobileFilterCategoryList } from "./useMobileFilterCategoryList";
type Props = {
  filters: FilterConfig[];
  pageKey: string;
  mobileHeader?: ReactNode;
};
export function MobileFilterCategoryList(t0) {
  const $ = _c(18);
  const {
    filters,
    pageKey,
    mobileHeader
  } = t0;
  const {
    openModal
  } = useModal();
  const t = useTranslations("modules.listings.listingsPage.filters");
  const {
    totalActiveFilters,
    filtersWithActiveCount,
    clearAllFilters
  } = useMobileFilterCategoryList(pageKey, filters);
  let t1;
  if ($[0] !== openModal || $[1] !== pageKey) {
    t1 = filter => {
      openModal(ModalTypeEnum.GENERIC_SHEET, {
        title: filter.title,
        side: "bottom",
        className: "h-dvh flex flex-col",
        children: <MobileFilterCategorySheet pageKey={pageKey} filterId={filter.id} availableValues={filter.values} operatorOptions={filter.operatorValues.values} />
      });
    };
    $[0] = openModal;
    $[1] = pageKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSelectFilter = t1;
  let t2;
  if ($[3] !== filtersWithActiveCount || $[4] !== handleSelectFilter) {
    let t3;
    if ($[6] !== handleSelectFilter) {
      t3 = filter_0 => <button key={filter_0.id} onClick={() => handleSelectFilter(filter_0)} className="w-full flex items-center justify-between px-4 min-h-[56px] border-b last:border-b-0 text-left"><span className="text-zinc-800 text-base">{filter_0.title}</span><div className="flex items-center gap-2">{filter_0.activeCount > 0 && <span className="inline-flex items-center justify-center rounded-full bg-zinc-900 text-white text-xs w-5 h-5 shrink-0">{filter_0.activeCount}</span>}<ChevronRight className="size-4 text-zinc-400 shrink-0" /></div></button>;
      $[6] = handleSelectFilter;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = filtersWithActiveCount.map(t3);
    $[3] = filtersWithActiveCount;
    $[4] = handleSelectFilter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[8] !== mobileHeader || $[9] !== t2) {
    t3 = <div className="flex-1 min-h-0 overflow-y-auto scrollbar-none">{mobileHeader}{t2}</div>;
    $[8] = mobileHeader;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== clearAllFilters || $[12] !== t || $[13] !== totalActiveFilters) {
    t4 = totalActiveFilters > 0 && <div className="sticky bottom-0 p-4 border-t bg-white"><button onClick={clearAllFilters} className="w-full py-3 rounded-full bg-zinc-900 text-white text-sm font-medium">{t("clearAllFilters")}</button></div>;
    $[11] = clearAllFilters;
    $[12] = t;
    $[13] = totalActiveFilters;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="flex flex-1 min-h-0 flex-col" data-sentry-component="MobileFilterCategoryList" data-sentry-source-file="MobileFilterCategoryList.tsx">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}